/*
 * @Description: 学生评教
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const studentEvaluationRouter: Array<RouteRecordRaw> = [
    {
        path: '/studentEvaluation',
        component: Layout,
        redirect: '/studentEvaluation/studentEvaluationList',
        meta: { title: '评教列表' },
        children: [
            {
                path: 'studentEvaluationList',
                component: () => import(/* webpackChunkName: "studentEvaluationList" */ '@/views/studentEvaluation/list.vue'),
                name: 'studentEvaluationList',
                meta: { title: '学生评教' },
            },
            {
                path: 'addStudentEvaluationList',
                component: () => import(/* webpackChunkName: "addStudentEvaluationList" */ '@/views/studentEvaluation/addEvaluation.vue'),
                name: 'addStudentEvaluationList',
                meta: { title: '添加评教' },
            },
            {
                path: 'addStudentEvaluationEditPaper',
                component: () => import(/* webpackChunkName: "addStudentEvaluationEditPaper" */ '@/views/studentEvaluation/editPaper.vue'),
                name: 'addStudentEvaluationEditPaper',
                meta: { title: '编辑评教' },
            },
            {
                path: 'addStudentEvaluationPreviewPaper',
                component: () => import(/* webpackChunkName: "addStudentEvaluationPreviewPaper" */ '@/views/studentEvaluation/previewPaper.vue'),
                name: 'addStudentEvaluationPreviewPaper',
                meta: { title: '预览问卷' },
            },
            {
                path: 'addStudentEvaluationStatistics',
                component: () => import(/* webpackChunkName: "addStudentEvaluationStatistics" */ '@/views/studentEvaluation/Statistics.vue'),
                name: 'addStudentEvaluationStatistics',
                meta: { title: '评教统计' },
            },
        ]
    }
]

export default studentEvaluationRouter
